import { Injectable, inject } from '@angular/core';
import { Bundle } from '@formunauts/shared/bundle/data-access';
import { bundleShortVersionString } from '@formunauts/shared/bundle/domain';

@Injectable({ providedIn: 'root' })
export class NextVersionService {
  /** Version tag for data created via next. */
  readonly dataTag = `next-${bundleShortVersionString(inject(Bundle).version)}`;
}
